const selectPortalProps = {
    menuPortalTarget: document.body,
    menuPosition: "fixed",
    maxMenuHeight: 200,
    styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
};

export const MAX_ARTIFACT_FILE_SIZE_BYTES = 100 * 1024 * 1024; // 100 MB

export const getArtifactFormFields = (deviceModels, handleFileChange, mode = "create", parsedData = null) => {
    const artifactNameField = {
        name: "artifactName",
        label: "Artifact Name",
        type: "text",
        required: mode === "create",
        rules: {
            maxLength: {
                value: 200,
                message: "Artifact name cannot exceed 200 characters"
            }
        },
        className: "artifact-col-6",
    };

    const deviceModelField = {
        name: "deviceModelId",
        label: "Device Model",
        type: "select",
        required: mode === "create",
        rules: {
            validate: value => value ? true : "Device Model is required"
        },
        options: deviceModels.map(m => ({
            label: m.name,
            value: m.id
        })),
        className: mode === "create" ? "artifact-col-6" : "artifact-col-12",
        selectProps: selectPortalProps,
    };

    const artifactTypeField = {
        name: "artifactType",
        label: "Artifact Type",
        type: "select",
        required: mode === "create",
        rules: {
            validate: value => value ? true : "Artifact Type is required"
        },
        options: [
            { label: "SOFTWARE", value: "SOFTWARE" },
            { label: "FIRMWARE", value: "FIRMWARE" },
            { label: "AI_MODEL", value: "AI_MODEL" },
        ],
        className: "artifact-col-6",
        selectProps: selectPortalProps,
    };

    const releaseChannelField = {
        name: "releaseChannel",
        label: "Release Channel",
        type: "select",
        required: mode === "create",
        rules: {
            validate: value => value ? true : "Release Channel is required"
        },
        options: [
            { label: "ALPHA", value: "ALPHA" },
            { label: "BETA", value: "BETA" },
            { label: "GA", value: "GA" },
        ],
        className: "artifact-col-6",
        selectProps: selectPortalProps,
    };

    const fileSizeBytesField = {
        name: "fileSizeBytes",
        label: "File Size (Bytes)",
        type: "text",
        className: "artifact-col-6",
    };

    const checksumField = {
        name: "checksum",
        label: "Checksum (MD5)",
        type: "text",
        className: "artifact-col-6",
    };

    const isConsentRequiredField = {
        name: "isConsentRequired",
        label: "Is User Consent Required?",
        type: "checkbox",
        className: "artifact-col-6 artifact-checkbox",
    };

    if (mode === "create") {
        const fileField = {
            name: "file",
            label: "Upload OTA Package (.pkg)",
            type: "file",
            required: true,
            rules: {
                validate: {
                    fileRequired: (value) => (value ? true : "OTA package file is required"),
                    isPkg: (value) =>
                        !value || value.name?.toLowerCase().endsWith(".pkg")
                            ? true
                            : "File must be a .pkg OTA package",
                    maxSize: (value) =>
                        !value || value.size <= MAX_ARTIFACT_FILE_SIZE_BYTES
                            ? true
                            : `File must not exceed ${MAX_ARTIFACT_FILE_SIZE_BYTES / (1024 * 1024)} MB`,
                },
            },
            onChange: handleFileChange,
            className: "artifact-col-12",
        };

        const parsedFieldVisibility = parsedData ? "artifact-col-6" : "artifact-col-6 artifact-field-hidden";
        const fields = [
            artifactNameField,
            artifactTypeField,
            releaseChannelField,
            isConsentRequiredField,
            fileField,
            deviceModelField,
            fileSizeBytesField,
            checksumField,
            { name: "versionString", label: "Version (from package)", type: "text", className: parsedFieldVisibility },
            { name: "otaType", label: "OTA Type", type: "text", className: parsedFieldVisibility },
            { name: "headerVersion", label: "Header Version", type: "text", className: parsedFieldVisibility },
            { name: "buildTime", label: "Build Time", type: "text", className: parsedFieldVisibility },
            { name: "vendorId", label: "Vendor ID", type: "text", className: parsedFieldVisibility },
            { name: "productId", label: "Product ID", type: "text", className: parsedFieldVisibility },
            { name: "minRequiredVersion", label: "Min Required Version", type: "text", className: parsedFieldVisibility },
            { name: "minHwVersion", label: "Min Hardware Version", type: "text", className: parsedFieldVisibility },
            { name: "payloadLengthMb", label: "Payload Size", type: "text", className: parsedFieldVisibility },
            { name: "payloadMd5", label: "Payload Checksum (MD5)", type: "text", className: parsedFieldVisibility },
        ];

        return fields;
    }

    // Edit mode (UpdateArtifactModal.js): unchanged field set/order.
    return [
        artifactNameField,
        {
            name: "version",
            label: "Version",
            type: "text",
            rules: {
                maxLength: {
                    value: 50,
                    message: "Version cannot exceed 50 characters"
                }
            },
            className: "artifact-col-6",
        },
        deviceModelField,
        artifactTypeField,
        releaseChannelField,
        {
            name: "file",
            label: "Upload File",
            type: "file",
            className: "artifact-col-12",
        },
        fileSizeBytesField,
        checksumField,
        isConsentRequiredField,
    ];
};
